

export const frontMatter = {
	sidebar_position: 2,
	license: 'republish',
	author: 'Jan van Steenbergen',
	custom_edit_url: '/501',
	last_update: {
		author: 'Google Translate'
	},
	origin: 'http://steen.free.fr/interslavic/history.html'
};
export const contentTitle = 'Krótka historia międzysłowiańska';
export {default as metadata} from '@site/.docusaurus/docusaurus-plugin-content-docs/default/site-i-18-n-pl-docusaurus-plugin-content-docs-current-learn-misc-history-md-581.json'
export const assets = {

};

import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const toc = [];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    blockquote: "blockquote",
    code: "code",
    em: "em",
    h1: "h1",
    header: "header",
    p: "p",
    span: "span",
    strong: "strong",
    ..._provideComponents(),
    ...props.components
  }, {CustomAfterSection} = _components;
  if (!CustomAfterSection) _missingMdxReference("CustomAfterSection", true);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.header, {
      children: _jsx(_components.h1, {
        id: "krótka-historia-międzysłowiańska",
        children: "Krótka historia międzysłowiańska"
      })
    }), "\n", _jsx(_components.p, {
      children: "Historia języka międzysłowiańskiego jest ściśle związana z panslawizmem, ideologią uznającą Słowian za jeden naród i dążącą do ich kulturowego i politycznego zjednoczenia. Wraz z ideą wspólnego państwa słowiańskiego pojawia się także idea wspólnego języka słowiańskiego. Od początku zastanawiano się, jak ten język powinien wyglądać."
    }), "\n", _jsxs(_components.p, {
      children: ["Silnym kandydatem zawsze był ", _jsx(_components.strong, {
        children: "rosyjski"
      }), ", pod względem użytkowników zdecydowanie największy język słowiański. Obecnie jest językiem ojczystym blisko połowy Słowian, a posługuje się nim (prawie) płynnie kolejne 15–20%. Poza tym Rosja zawsze była wielkim imperium, regionalnym supermocarstwem i jest jedynym krajem słowiańskim o nieprzerwanej tradycji państwowości. Nic dziwnego, że język rosyjski był popierany jako język pansłowiański głównie przez rosyjskich panslawistów, którzy zawsze dawali jasno do zrozumienia, że rosyjska hegemonia jest conditio sine qua non dla państwa słowiańskiego, i właśnie dlatego idea ta nigdy nie zyskała popularności. dużą popularnością wśród mniejszych narodów słowiańskich. Mimo że uznają swoje kulturowe związki z Rosją, nie chcą być traktowani jako „oszpeceni Rosjanie”, a większość z nich nie ma najlepszych doświadczeń z rosyjską dominacją. Ponadto rosyjski nie jest językiem prostym i posiada wiele cech, które utrudniają jego zrozumienie osobom posługującym się innymi językami słowiańskimi."]
    }), "\n", _jsxs(_components.p, {
      children: ["Innym popularnym kandydatem jest ", _jsx(_components.strong, {
        children: "staro-cerkiewno-słowiański"
      }), ", najstarszy pisany język słowiański, skodyfikowany (lub według niektórych stworzony) w IX wieku przez braci św. Cyryla i św. Metodego. Język ten ma kilka zalet: jest bardzo blisko spokrewniony ze wspólnym przodkiem języków słowiańskich i ma długą tradycję używania w liturgii prawosławnej, będąc tym samym zarówno wspólną płaszczyzną, jak i wspólnym wpływem dla wielu języków słowiańskich. Ma tę dodatkową zaletę, że nie jest niczyim językiem ojczystym, dzięki czemu można go łatwo przedstawić jako neutralny, międzynarodowy język podobny do łaciny czy sanskrytu. Jednak pomimo tych zalet język staro-cerkiewno-słowiański ma również kilka praktycznych wad. Fakt, że był to język sakralny, uczynił go szczególnie odpornym na zmiany, tak że nawet późniejsze „redakcje” są niewiele więcej niż oryginał z domieszką ", _jsx(_components.em, {
        children: "couleur locale"
      }), ". W rezultacie język staro-cerkiewno-słowiański ma obficie bogaty ortografię zawierającą kilka znaków i dźwięków, które wypadły z użycia, równie bogatą i przez to skomplikowaną gramatykę oraz niezwykle archaiczne słownictwo, zawierające słowa, które nie przetrwały w żadnym ze współczesnych języków, ale brakuje słów dla współczesnych pojęć. Już w XVII wieku Juraj Križanić , prawdopodobnie pierwszy panslawista, zauważył, że język staro-cerkiewno-słowiański stał się zbyt archaiczny, aby był możliwy jako język pansłowiański. Innymi słowy, wymagałoby to gruntownej modernizacji i tu właśnie wkracza ", _jsx(_components.strong, {
        children: "intersłowiański"
      }), ". Można powiedzieć, że międzysłowiański zaczyna się tam, gdzie kończy się staro-cerkiewno-słowiański."]
    }), "\n", _jsxs(_components.p, {
      children: ["Križanić był pierwszym, który faktycznie opisał język, który nazwał ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Ruski"
        })
      }), ", starając się zadowolić cara, ale który w rzeczywistości był mieszanką rosyjsko-cerkiewno-słowiańskiego i chorwackiego, a także elementów innych języków słowiańskich, zwłaszcza polskiego. Został ukończony w 1666 roku i jest często cytowany jako pierwszy skonstruowany język międzysłowiański. W późniejszych latach za jego przykładem poszło wielu innych. W XIX wieku, kiedy panslawizm przeżywał swój rozkwit, światło dzienne ujrzało kolejnych dziesięć projektów autorów czeskich, słowackich, słoweńskich i chorwackich. Spośród nich najbardziej rozbudowane były: ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Universalis Lingua Slavica"
        })
      }), ", opublikowany w 1826 r. przez Słowaka Jána Herkeľa, język oparty głównie na językach zachodniosłowiańskich; ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Vsjeslovianьskyь"
        })
      }), ", oparty na cerkiewno-słowiańskim, wydany w 1861 r. przez czeskiego Vaceslava Bambasa; i ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Uzajemni Pravopis Slavjanski"
        })
      }), ", opublikowane w 1865 roku przez Słoweńca Matija Majara-Ziljskiego. Podczas gdy większość projektów miała na celu odrodzenie i unowocześnienie (staro) cerkiewno-słowiańskiego, Majar wybrał zupełnie inne podejście. Jego projekt opierał się na założeniu, że Słowianie mogą stać się bardziej zrozumiałi dla innych Słowian, biorąc za punkt wyjścia swój własny język, a następnie stopniowo go modyfikując. Pierwszym krokiem w tym procesie była zmiana ortografii, w wyniku której powstała ogólna („wzajemna”) ortografia pansłowiańska. Następnie zaproponował gramatykę opartą na porównaniu językowym pięciu głównych języków słowiańskich tamtych czasów: rosyjskiego, polskiego, czeskiego, serbskiego i staro-cerkiewno-słowiańskiego."]
    }), "\n", _jsxs(_components.p, {
      children: ["W XX wieku pojawiło się kilka nowych projektów, głównie autorów czeskich. Podczas gdy poprzednie projekty były głównie akademickimi ekstrapolacjami, problemem stała się również prostota. Niektóre projekty, takie jak ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Neposlava"
        })
      }), " Wsiewołoda Czeszikina, ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Slavski"
        })
      }), " Bohumila Holégo i ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Slovio"
        })
      }), " Marka Hučko, były pod silnym wpływem esperanto. Z drugiej strony, naturalistyczna ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Mežduslavjanski jezik"
        })
      }), " Ladislava Podmele z lat 50. oparta była głównie na języku rosyjskim, prawdopodobnie ze względu na ówczesne realia polityczne."]
    }), "\n", _jsxs(_components.p, {
      children: ["Chociaż większość z wyżej wymienionych projektów była rozbudowana i wykorzystana w różnych publikacjach, były to pojedyncze wysiłki pojedynczych osób i wydaje się mało prawdopodobne, aby którykolwiek z nich kiedykolwiek miał znaczną liczbę zwolenników. Era cyfrowa otworzyła przed Intersłowianem wiele nowych możliwości. Przede wszystkim rosnące możliwości interakcji z ludźmi w innych krajach, na listach mailingowych, forach internetowych itp., spowodowały ponowne zainteresowanie językiem zrozumiałym dla Słowian różnych narodowości. Po drugie, intersłowiańszczyzna nie była już domeną językoznawców i panslawistów, a każdy miał teraz szansę podzielić się swoimi pomysłami w Internecie. Po trzecie, dzięki nowym środkom komunikacji, autorzy nie byli już zmuszani do pracy w odosobnieniu. Tak więc na początku XXI wieku obserwujemy przejście od projektów solowych do projektów kooperacyjnych, a następnie tendencję do ich integracji. Pierwszy wspólny projekt nazywał się ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Slovo"
        })
      }), " i działał w latach 2001-2002, ale potem został przerwany."]
    }), "\n", _jsx(_components.p, {
      children: "Wspólne projekty miały kilka istotnych zalet w porównaniu z projektami indywidualnymi. Poprzednie projekty, bez względu na to, jak dobrze zbudowane, zawsze były zabarwione pochodzeniem etnicznym ich autorów, z których większość tradycyjnie stanowili Czesi, Słoweńcy i Chorwaci. Po raz pierwszy rolę zaczęły odgrywać także wkłady Rosjan, Polaków, Serbów i Bułgarów. Ponieważ ludzie różnych narodowości byli ze sobą w stałym kontakcie i mieli dostęp do tych samych źródeł, stało się możliwe zrobienie czegoś, czego nigdy wcześniej nie robiono, a mianowicie zbudowanie słownika międzysłowiańskiego. Poza tym projekt językowy, nad którym pracował kolektyw zamiast indywidualnego autora, od razu miał do dyspozycji podstawową społeczność użytkowników i zakres testowy."
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Slovianski project"
        })
      }), " powstał w marcu 2006 r., częściowo w odpowiedzi na wysoce sztuczny charakter Slovio, w tamtym czasie jedynego aktywnego słowiańskiego języka sztucznego. Opierała się na tej samej koncepcji porównania językowego, którą zastosował Majar-Ziljski. Wzięto pod uwagę wszystkie żywe języki słowiańskie, którymi posługuje się co najmniej 1 milion osób, w taki sposób, że zachodni, wschodni i południowy słowiański otrzymały taką samą wagę. Na początku projektu autorzy eksperymentowali z różnymi wersjami języka. ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Slovianski-P"
        })
      }), " (litera ", _jsx(_components.code, {
        children: "P"
      }), " odnosi się do słowa ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        lang: "en",
        children: "pidgin"
      }), " lub ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: "prosti"
      }), ", słowiańskiego słowa oznaczającego „prosty”), po raz pierwszy zaproponowany przez Ondreja Rečnika, a później przyjęty przez Gabriela Svobodę, miał stać się językiem bardzo uproszczonym , zbudowane na podobnych zasadach jak języki pidgin. ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Slovianski-N"
        })
      }), " (litera ", _jsx(_components.code, {
        children: "N"
      }), " oznacza „naturalizm”), zapoczątkowany przez Jana van Steenbergena, a później rozwinięty przez Igora Polyakova, opierał się na wszystkim, co łączy języki słowiańskie, łącznie z systemem przypadków. W końcu ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Slovianski-S"
        })
      }), " (litera ", _jsx(_components.code, {
        children: "S"
      }), " oznacza „schematyzm”) było wysiłkiem Gabriela Svobody (", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "GS-Slovianski"
        })
      }), ") i Igora Polyakova (", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Slovjanskaj"
        })
      }), ") w celu stworzenia języka łączącego schematyzm z naturalizmem. Wszystkie trzy pracowały jako oddzielne projekty siostrzane lub „dialekty”, oparte na różnych modelach gramatycznych, ale mające wspólną ortografię, fonologię i słownictwo. Stopniowo ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Slovianski-S"
        })
      }), " i ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Slovianski-P"
        })
      }), " zostały porzucone, aw 2009 roku zdecydowano, że ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Slovianski-N"
        })
      }), " będzie nosić nazwę ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Slovianski"
        })
      }), ", podczas gdy ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Slovianski-P"
        })
      }), " będzie nadal istnieć jako jej uproszczona wersja, przydatna do komunikacji z Bułgarami , Macedończycy i nie-Słowianie."]
    }), "\n", _jsxs(_components.p, {
      children: ["W międzyczasie podjęto osobne wysiłki, aby wypełnić lukę między ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Slovianski"
        })
      }), " i ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Slovio"
        })
      }), ", łącząc (zmodyfikowaną formę) gramatyki ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Slovianski"
        })
      }), " z większym słownikiem ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Slovio's"
        })
      }), ". W 2008 roku Rosjanin Hellerick oświadczył się ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Rozumio"
        })
      }), ", o czym pisał:"]
    }), "\n", _jsxs(_components.blockquote, {
      children: ["\n", _jsxs(_components.p, {
        children: [_jsx(_components.span, {
          className: "notranslate",
          translate: "no",
          children: _jsx(_components.strong, {
            children: "Rozumio"
          })
        }), " nie jest językiem, a raczej próbą połączenia dwóch słowiańskich konlangów pomocniczych ", _jsx(_components.span, {
          className: "notranslate",
          translate: "no",
          children: _jsx(_components.strong, {
            children: "Slovio"
          })
        }), " i ", _jsx(_components.span, {
          className: "notranslate",
          translate: "no",
          children: _jsx(_components.strong, {
            children: "Slovianski"
          })
        }), ". Język jest oparty na ", _jsx(_components.span, {
          className: "notranslate",
          translate: "no",
          children: _jsx(_components.strong, {
            children: "Slovio"
          })
        }), ", a mimo to można go uznać za rodzaj ", _jsx(_components.span, {
          className: "notranslate",
          translate: "no",
          children: _jsx(_components.strong, {
            children: "Slovianski"
          })
        }), " w jego pierwotnej formie."]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["Ten sam pomysł podchwycili również w lutym 2009 roku Steeven Radzikowski, Andrej Moraczewski i Michał Borovička, kiedy rozpoczęli nowy projekt, początkowo nazwany ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Slavju Slovio"
        })
      }), " („", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Slavic Slovio"
        })
      }), "“), a wkrótce nazwany ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Slovioski"
        })
      }), ". W przeciwieństwie do Rozumia, Słowiański szybko rozwinął się w odrębny projekt językowy. Pierwotnym pomysłem było zastąpienie gramatyki ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Slovio's"
        })
      }), " bardziej naturalistyczną, przy jednoczesnym zasadniczo trzymaniu się słownika ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Slovio"
        })
      }), ". Tak jak ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Slovianski"
        })
      }), ", ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Slovioski"
        })
      }), "  miał trzy wersje, czyli „poziomy”: ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Prostij Slovioski"
        })
      }), ", ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Srednij Slovioski"
        })
      }), "  i ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Polnij Slovioski"
        })
      }), ". Ten ostatni był praktycznie identyczny z ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Slovianski"
        })
      }), ". W 2010 roku ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Srednij Slovioski"
        })
      }), " został zlikwidowany, słownik ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Slovio"
        })
      }), " porzucony, a sam Słowiański został przemianowany na ", _jsx(_components.strong, {
        children: "Intersłowiański"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["We wszystkich wersjach ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Slovianski"
        })
      }), " i ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Slovioski"
        })
      }), " duży wpływ miało na nie przekonanie, że język pomocniczy powinien być prosty. Nawet ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Slovianski-N"
        })
      }), " – pomimo tego, że ma rodzaj i przypadek – miał bardzo uproszczony system odmieniania rzeczowników i koniugacji czasowników. Jednak oba projekty wykazywały rosnącą tendencję do przedkładania rozwiązań naturalnych nad prostotę. W efekcie w obu projektach ostatecznie dominował pierwiastek naturalistyczny. Ten zwrot w kierunku naturalizmu został jeszcze bardziej wzmocniony po wejściu na scenę nowego projektu: ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Novoslovienskij"
        })
      }), " („", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Neoslavonic"
        })
      }), "”), opublikowanego w 2010 roku przez Vojtěcha Merunkę. W przeciwieństwie do ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Slovianski"
        })
      }), " i ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Slovioski"
        })
      }), ", opierał się bezpośrednio na języku staro-cerkiewno-słowiańskim, który próbował unowocześnić, upraszczając ortografię i rozszerzając ją o nowoczesne słownictwo zaczerpnięte z ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Slovianski"
        })
      }), ", zachowując jednocześnie archaiczne elementy, takie jak wiele czasów przeszłych i podwójny ."]
    }), "\n", _jsxs(_components.p, {
      children: ["Od tego czasu wszystkie trzy projekty ściśle ze sobą współpracowały, aw 2011 ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Medžuslovjanski"
        })
      }), " („Interslavic”) zostało wybrane jako wspólny pseudonim. Owocem tej współpracy były między innymi wspólny słownik, wspólny portal informacyjny oraz wspólna wiki. Gdy nacisk w coraz większym stopniu przesuwał się z prostoty na elastyczność, ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Slovianski"
        })
      }), " rozwinął się z języka o ustalonych regułach w bardziej elastyczny język z prototypową ortografią, którą można było łatwo przekształcić zgodnie z własnymi potrzebami, dwoma różnymi poziomami gramatyki i różnymi możliwościami [dodatków] 1]. Ta wielopoziomowa gramatyka obejmowała bardzo uproszczony model gramatyki, ", _jsx(_components.strong, {
        children: "Slovianto"
      }), ", opracowany w celu zastąpienia zarówno ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Slovianski-P"
        })
      }), ", jak i ", _jsx(_components.strong, {
        children: "Prostij Slovioski"
      }), ", oraz bardziej zaawansowaną gramatykę opartą na ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Slovianski"
        })
      }), ", Novosloviensky i różnych starszych projektów i mające na celu ich integrację. W tym czasie Slovioski przestał istnieć jako odrębny projekt."]
    }), "\n", _jsxs(_components.p, {
      children: ["W następnych latach ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Medžuslovjanski"
        })
      }), " i ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Novoslovienskij"
        })
      }), " (wkrótce przemianowane na ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Novoslověnsky"
        })
      }), ") stopniowo zbliżały się do siebie. Ich społeczności użytkowników składały się w dużej mierze z tych samych osób, które często łączyły elementy z obu projektów. W rezultacie większość różnic między obydwoma projektami w naturalny sposób zniknęła."]
    }), "\n", _jsxs(_components.p, {
      children: ["W dniach 1 i 2 czerwca 2017 r. w Staré Město k. Uherské Hradiště w Czechach odbyła się Pierwsza Konferencja Języka Międzysłowiańskiego (", _jsx(_components.a, {
        href: "http://cisla.slavic-union.org/",
        children: "CISLa 2017"
      }), "), wpisana w czwartą edycję festiwalu Dni Kultury Słowiańskiej. Z 64 uczestnikami z 12 różnych krajów, konferencja stała się kamieniem milowym w historii Międzysłowiańskiej, ponieważ po raz pierwszy została wykorzystana podczas oficjalnego, publicznego wydarzenia. Była to również wyjątkowa okazja do sprawdzenia języka: większość prezentacji i dyskusji odbywała się w języku międzysłowiańskim lub tłumaczona konsekutywnie na język międzysłowiański, co okazało się wystarczające, aby wszyscy słowiańscy uczestnicy – w tym Polacy i Bułgarzy – zrozumieli praktycznie wszystko. Niezwykłym i dość nieoczekiwanym efektem ubocznym było to, że kilku uczestników, którzy nigdy nie uczyli się języka nowosłowiańskiego, nagle podczas konferencji zaczęło go używać."]
    }), "\n", _jsxs(_components.p, {
      children: ["Kolejnym efektem konferencji było to, że główni autorzy obu projektów, Jan van Steenbergen i Vojtěch Merunka, postanowili w pełni połączyć swoje projekty, ponieważ praca z dwoma podobnymi, ale nie identycznymi standardami stała się uciążliwa. Zaraz po konferencji utworzyli komisję z trzema innymi biegłymi mówcami języka intersłowiańskiego (Roberto Lombino, Michał Swat i Pavel Skrylev), której zadaniem było wykrycie i wyeliminowanie wszelkich różnic między obiema gramatykami. Do końca lipca zadanie to zostało wykonane. Po fuzji nazwa języka to ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Medžuslovjansky"
        })
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["Od tego momentu nowa, zjednoczona Międzysłowiańska przeżywała szybki rozwój. W tym samym roku powstało czasopismo naukowe ", _jsx(_components.a, {
        href: "http://slovjani.info/",
        children: "Slovjani.info"
      }), ", w którym publikowane były artykuły w języku intersłowiańskim lub streszczenia w języku intersłowiańskim. W maju 2018 r. odbyła się druga konferencja w Czechach, w której wzięło udział 67 uczestników. W tym samym okresie Interslavic był prezentowany na kilku międzynarodowych konferencjach, m.in. w Podgoricy, Poznaniu, Łodzi i Moskwie."]
    }), "\n", _jsxs(_components.p, {
      children: ["Kolejny kamień milowy nastąpił we wrześniu 2019 roku, kiedy podczas 76. Festiwalu Filmowego w Wenecji miał swoją premierę film Václava Marhoula ", _jsx(_components.a, {
        href: "http://steen.free.fr/interslavic/the_painted_bird.html",
        children: "Malowany ptak"
      }), " ", _jsx(_components.em, {
        children: "(na podstawie tytułowej powieści Jerzego Kosińskiego)"
      }), ". Aby zbudować wrażenie nieokreślonego kraju słowiańskiego, większość dialogów została napisana w języku międzysłowiańskim. Film spotkał się z uznaniem krytyków, otrzymał wiele nagród i został czeskim kandydatem do Oscarów 2020. Po czeskiej premierze filmu odbyła się międzysłowiańska minikonferencja w Pradze."]
    }), "\n", _jsxs(_components.p, {
      children: ["Rozgłos w drugiej połowie 2019 roku spowodował ogromną ekspansję społeczności międzysłowiańskiej. W ciągu sześciu miesięcy główne miejsce spotkań na ", _jsx(_components.a, {
        href: "https://www.facebook.com/groups/interslavic",
        children: "Facebooku"
      }), " rozrosło się z 1900 do 9000 członków ze 100 krajów."]
    }), "\n", _jsx(CustomAfterSection, {})]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}

